export const isDev = () => window.location.href?.toLowerCase().includes('local');
